import settings from '@/settings'

let cadastrarUsuarioFrentista = (frentista, data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/cadastrarusuario/${frentista}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let conectarPessoa = (frentista, posto, pessoa, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/conectarpessoa/${frentista}/`, {
    method: 'PUT',
    body: JSON.stringify({
      'cnpj': posto,
      'id_pessoa': pessoa
    }),
    mode: 'cors',
    headers: headers
  })
}

let verificarPessoa = (cpf, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/verificarcpf/?cpf=${cpf}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserirFrentista = (frentista, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(frentista),
    mode: 'cors',
    headers: headers
  })
}

let listaFrentistas = (cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/getbyposto/?cnpj=${cnpjPosto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let detalharFrentista = (id, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/detalhesfrentista/?id=${id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inativarFrentista = (headers, data) => {
  return fetch(`${settings.apetrusApi}/frentistas/inativarfrentista/?id=${data.id}`, {
    method: 'put',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

const get = (headers, filtros) => {
  let url = `${settings.apetrusApi}/frentistas/`
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const put = (headers, data) => {
  return fetch(`${settings.apetrusApi}/frentistas/editar/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

let avaliacaoFrentista = (cnpj, id, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/avaliarFrentista/?cnpj=${cnpj}&id_frentista=${id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  conectarPessoa,
  cadastrarUsuarioFrentista,
  inserirFrentista,
  listaFrentistas,
  detalharFrentista,
  inativarFrentista,
  verificarPessoa,
  get,
  put,
  avaliacaoFrentista
}
